import * as ambassadorWixStoresV1SubscriptionOption from './stores-v1-subscription-option-subscription-options.http.js';
import * as ambassadorWixStoresV1SubscriptionOptionTypes from './stores-v1-subscription-option-subscription-options.types.js';
import * as ambassadorWixStoresV1SubscriptionOptionUniversalTypes from './stores-v1-subscription-option-subscription-options.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getSubscriptionOption(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.GetSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.GetSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.GetSubscriptionOptionResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.GetSubscriptionOptionResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.getSubscriptionOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/subscription-options/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSubscriptionOptionsForProduct(): __PublicMethodMetaInfo<
  'GET',
  { productId: string },
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.GetSubscriptionOptionsForProductRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.GetSubscriptionOptionsForProductRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.GetSubscriptionOptionsForProductResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.GetSubscriptionOptionsForProductResponse
> {
  const payload = { productId: ':productId' } as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.getSubscriptionOptionsForProduct(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/subscription-options/byProduct/{productId}',
    pathParams: { productId: 'productId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getProductIdsForSubscriptionOption(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.GetProductIdsForSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.GetProductIdsForSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.GetProductIdsForSubscriptionOptionResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.GetProductIdsForSubscriptionOptionResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.getProductIdsForSubscriptionOption(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/subscription-options/{id}/productIds',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getOneTimePurchasesStatus(): __PublicMethodMetaInfo<
  'GET',
  { productId: string },
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.GetOneTimePurchasesStatusRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.GetOneTimePurchasesStatusRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.GetOneTimePurchasesStatusResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.GetOneTimePurchasesStatusResponse
> {
  const payload = { productId: ':productId' } as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.getOneTimePurchasesStatus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/subscription-options/product/{productId}/oneTimePurchasesStatus',
    pathParams: { productId: 'productId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createSubscriptionOption(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.CreateSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.CreateSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.CreateSubscriptionOptionResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.CreateSubscriptionOptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.createSubscriptionOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/subscription-options',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateSubscriptionOption(): __PublicMethodMetaInfo<
  'PATCH',
  { subscriptionOptionId: string },
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.UpdateSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.UpdateSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.UpdateSubscriptionOptionResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.UpdateSubscriptionOptionResponse
> {
  const payload = {
    subscriptionOption: { id: ':subscriptionOptionId' },
  } as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.updateSubscriptionOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/subscription-options/{subscriptionOption.id}',
    pathParams: { subscriptionOptionId: 'subscriptionOptionId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteSubscriptionOption(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.DeleteSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.DeleteSubscriptionOptionRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.DeleteSubscriptionOptionResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.DeleteSubscriptionOptionResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.deleteSubscriptionOption(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/subscription-options/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateSubscriptionOptions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.BulkCreateSubscriptionOptionsRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.BulkCreateSubscriptionOptionsRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.BulkCreateSubscriptionOptionsResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.BulkCreateSubscriptionOptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.bulkCreateSubscriptionOptions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/subscription-options/createBulk',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateSubscriptionOptions(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.BulkUpdateSubscriptionOptionsRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.BulkUpdateSubscriptionOptionsRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.BulkUpdateSubscriptionOptionsResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.BulkUpdateSubscriptionOptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.bulkUpdateSubscriptionOptions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/subscription-options',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteSubscriptionOptions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.BulkDeleteSubscriptionOptionsRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.BulkDeleteSubscriptionOptionsRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.BulkDeleteSubscriptionOptionsResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.BulkDeleteSubscriptionOptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.bulkDeleteSubscriptionOptions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/subscription-options/deleteBulk',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function assignSubscriptionOptionsToProduct(): __PublicMethodMetaInfo<
  'POST',
  { productId: string },
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.AssignSubscriptionOptionsToProductRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.AssignSubscriptionOptionsToProductRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.AssignSubscriptionOptionsToProductResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.AssignSubscriptionOptionsToProductResponse
> {
  const payload = { productId: ':productId' } as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.assignSubscriptionOptionsToProduct(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/subscription-options/product/{productId}/assign',
    pathParams: { productId: 'productId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function allowOneTimePurchases(): __PublicMethodMetaInfo<
  'PATCH',
  { productId: string },
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.AllowOneTimePurchasesRequest,
  ambassadorWixStoresV1SubscriptionOptionTypes.AllowOneTimePurchasesRequest,
  ambassadorWixStoresV1SubscriptionOptionUniversalTypes.AllowOneTimePurchasesResponse,
  ambassadorWixStoresV1SubscriptionOptionTypes.AllowOneTimePurchasesResponse
> {
  const payload = { productId: ':productId' } as any;

  const getRequestOptions =
    ambassadorWixStoresV1SubscriptionOption.allowOneTimePurchases(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/subscription-options/product/{productId}/allowOneTimePurchase',
    pathParams: { productId: 'productId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SubscriptionOption as SubscriptionOptionOriginal,
  SubscriptionSettings as SubscriptionSettingsOriginal,
  SubscriptionFrequency as SubscriptionFrequencyOriginal,
  SubscriptionFrequencyWithLiterals as SubscriptionFrequencyWithLiteralsOriginal,
  Discount as DiscountOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  GetSubscriptionOptionRequest as GetSubscriptionOptionRequestOriginal,
  GetSubscriptionOptionResponse as GetSubscriptionOptionResponseOriginal,
  GetSubscriptionOptionsForProductRequest as GetSubscriptionOptionsForProductRequestOriginal,
  GetSubscriptionOptionsForProductResponse as GetSubscriptionOptionsForProductResponseOriginal,
  SubscriptionOptionInProduct as SubscriptionOptionInProductOriginal,
  ListSubscriptionOptionsRequest as ListSubscriptionOptionsRequestOriginal,
  ListSubscriptionOptionsResponse as ListSubscriptionOptionsResponseOriginal,
  CalculatePricesRequest as CalculatePricesRequestOriginal,
  CalculatePricesResponse as CalculatePricesResponseOriginal,
  SubscriptionOptionPrices as SubscriptionOptionPricesOriginal,
  SubscriptionOptionPriceData as SubscriptionOptionPriceDataOriginal,
  BulkCalculatePricesRequest as BulkCalculatePricesRequestOriginal,
  BulkCalculatePricesResponse as BulkCalculatePricesResponseOriginal,
  BulkCalculatePricesRequestV2 as BulkCalculatePricesRequestV2Original,
  BulkCalculatePricesRequestItem as BulkCalculatePricesRequestItemOriginal,
  BulkCalculatePricesResponseV2 as BulkCalculatePricesResponseV2Original,
  BulkCalculatePricesResponseItem as BulkCalculatePricesResponseItemOriginal,
  GetProductIdsForSubscriptionOptionRequest as GetProductIdsForSubscriptionOptionRequestOriginal,
  Paging as PagingOriginal,
  GetProductIdsForSubscriptionOptionResponse as GetProductIdsForSubscriptionOptionResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  GetOneTimePurchasesStatusRequest as GetOneTimePurchasesStatusRequestOriginal,
  GetOneTimePurchasesStatusResponse as GetOneTimePurchasesStatusResponseOriginal,
  CreateSubscriptionOptionRequest as CreateSubscriptionOptionRequestOriginal,
  CreateSubscriptionOptionResponse as CreateSubscriptionOptionResponseOriginal,
  UpdateSubscriptionOptionRequest as UpdateSubscriptionOptionRequestOriginal,
  UpdateSubscriptionOptionResponse as UpdateSubscriptionOptionResponseOriginal,
  DeleteSubscriptionOptionRequest as DeleteSubscriptionOptionRequestOriginal,
  DeleteSubscriptionOptionResponse as DeleteSubscriptionOptionResponseOriginal,
  BulkCreateSubscriptionOptionsRequest as BulkCreateSubscriptionOptionsRequestOriginal,
  BulkCreateSubscriptionOptionsResponse as BulkCreateSubscriptionOptionsResponseOriginal,
  BulkUpdateSubscriptionOptionsRequest as BulkUpdateSubscriptionOptionsRequestOriginal,
  BulkUpdateSubscriptionOptionsResponse as BulkUpdateSubscriptionOptionsResponseOriginal,
  BulkDeleteSubscriptionOptionsRequest as BulkDeleteSubscriptionOptionsRequestOriginal,
  BulkDeleteSubscriptionOptionsResponse as BulkDeleteSubscriptionOptionsResponseOriginal,
  AssignSubscriptionOptionsToProductRequest as AssignSubscriptionOptionsToProductRequestOriginal,
  AssignSubscriptionOptionsToProductResponse as AssignSubscriptionOptionsToProductResponseOriginal,
  AllowOneTimePurchasesRequest as AllowOneTimePurchasesRequestOriginal,
  AllowOneTimePurchasesResponse as AllowOneTimePurchasesResponseOriginal,
} from './stores-v1-subscription-option-subscription-options.types.js';
